var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.0026 1.33301C4.32927 1.33301 1.33594 4.32634 1.33594 7.99967C1.33594 11.673 4.32927 14.6663 8.0026 14.6663C11.6759 14.6663 14.6693 11.673 14.6693 7.99967C14.6693 4.32634 11.6759 1.33301 8.0026 1.33301ZM10.9026 10.3797C10.8093 10.5397 10.6426 10.6263 10.4693 10.6263C10.3826 10.6263 10.2959 10.6063 10.2159 10.553L8.14927 9.31967C7.63594 9.01301 7.25594 8.33967 7.25594 7.74634V5.01301C7.25594 4.73967 7.4826 4.51301 7.75594 4.51301C8.02927 4.51301 8.25594 4.73967 8.25594 5.01301V7.74634C8.25594 7.98634 8.45594 8.33967 8.6626 8.45967L10.7293 9.69301C10.9693 9.83301 11.0493 10.1397 10.9026 10.3797Z",
    fill: "#919191"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock3);
export default __webpack_public_path__ + "static/media/clock_3.8b64c8fc925787a93bd9f3ffcd672876.svg";
export { ForwardRef as ReactComponent };